module.exports = __webpack_public_path__ + "img/form-grid-plus-icon.fb1a2c83.svg";